import { normalizeSrc } from '@/app/components/media/app-image/shared/image-source';
import {
  dedupeImageKitTransforms,
  imageKitParamsToTransforms,
  joinImageKitTransforms,
  parseImageKitTransforms,
} from '@/app/components/media/app-image/shared/imagekit-transform';
import { type ImageKitUrlOptions } from '@/app/components/media/app-image/shared/imagekit-types';
import {
  getQueryParams,
  mergeQuery,
} from '@/app/components/media/app-image/shared/url-query';

export const buildImageKitUrl = (
  srcInput: unknown,
  opts: ImageKitUrlOptions
): string => {
  const src = normalizeSrc(srcInput);
  if (!src) return '';

  const queryParams = getQueryParams(src);
  const existingTransforms = parseImageKitTransforms(queryParams.tr);
  const defaultTransforms = opts.defaultTransforms ?? [];
  const paramTransforms = imageKitParamsToTransforms(opts.params);
  const mergedTransforms = dedupeImageKitTransforms([
    ...defaultTransforms,
    ...existingTransforms,
    ...paramTransforms,
  ]);

  return mergeQuery(src, { tr: joinImageKitTransforms(mergedTransforms) });
};
